import React, { useEffect, useState } from 'react';
import makeRequest from 'utils/makeRequest';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () => import(/* webpackChunkName: 'IPLwidgetV2' */ './IPLWidget'),
  loading: () => null,
});

const IPLWidgetV2LoaderWrapper = props => {
  const { dataUrl } = props;
  const [isMatchAvailable, setIsMatchAvailble] = useState(false);
  useEffect(() => {
    if (dataUrl) {
      makeRequest.get(dataUrl).then(response => {
        const { data } = response;
        if (data && Array.isArray(data.matches) && data.matches.length > 0) {
          setIsMatchAvailble(true);
        }
      });
    }
  }, []);

  return isMatchAvailable ? <LoadableComponent {...props} /> : null;
};

export default IPLWidgetV2LoaderWrapper;
